/**
 * Contenu SEO local complet par ville — pages /taxi-[slug]
 * Miroir frontend : src/data/citySeoPages.js
 */

const CONTACT = {
  phoneDisplay: '06 62 10 71 42',
  phoneTel: '+33662107142',
  email: 'taxiabel42@gmail.com',
  companyName: 'TAXI ABEL',
  site: 'taxiabel.fr',
};

const DEFAULT_SERVICE_LINKS = [
  { slug: 'navette-aeroport', label: 'Navette aéroport Lyon / Grenoble' },
  { slug: 'transport-medical', label: 'Transport médical conventionné CPAM' },
  { slug: 'taxi-gare', label: 'Taxi gare (Châteaucreux, Part-Dieu…)' },
  { slug: 'taxi-nuit', label: 'Taxi de nuit 24h/24' },
  { slug: 'hopitaux-lyonnais', label: 'Transferts hôpitaux lyonnais' },
];

const CITY_PAGES = {
  'taxi-la-grand-croix': {
    name: 'La Grand-Croix',
    slug: 'taxi-la-grand-croix',
    postalCode: '42320',
    department: 'Loire (42)',
    distanceBase: '0 km',
    highlight: 'base opérationnelle TAXI ABEL',
    seo: {
      title: 'Taxi à La Grand-Croix 24h/24 – Aéroport, Gare | TAXI ABEL',
      description:
        'Taxi à La Grand-Croix 24h/24 : aéroport Lyon, gare Saint-Étienne, hôpitaux et transport CPAM. TAXI ABEL, tarifs officiels Loire. Réservation rapide.',
      h1: 'Taxi à La Grand-Croix – Service 24h/24, Aéroport, Gare & Transport Conventionné',
    },
    intro:
      'Basé à La Grand-Croix (42320, Loire), TAXI ABEL est votre référence taxi dans la Vallée du Gier. Depuis notre commune d\'implantation, nous assurons courses locales, longues distances, navettes aéroport Lyon-Saint-Exupéry et Grenoble, transferts gare Saint-Étienne Châteaucreux, trajets médicaux conventionnés CPAM et transport professionnel. Chauffeur agréé, véhicules confortables, disponibilité 24h/24 et 7j/7 : que vous partiez du centre-bourg, des quartiers résidentiels ou des zones d\'activités, votre taxi La Grand-Croix arrive rapidement. Estimez votre course avec notre calculateur en ligne ou appelez le 06 62 10 71 42.',
    frequentTrips: [
      { text: 'La Grand-Croix → Aéroport Lyon-Saint-Exupéry : environ 45 min et 65 km, navette avec suivi vol et aide bagages.' },
      { text: 'La Grand-Croix → Gare Saint-Étienne Châteaucreux : environ 20 min, idéal TGV, TER et correspondances métropole.' },
      { text: 'La Grand-Croix → CHU Saint-Étienne Nord / Bellevue : trajets médicaux ponctuels, dialyse et consultations.' },
      { text: 'La Grand-Croix → Lyon Part-Dieu / Perrache : environ 50 min selon trafic, accès gares et quartiers d\'affaires.' },
      { text: 'La Grand-Croix → Rive-de-Gier, Saint-Chamond, Lorette : courses quotidiennes dans la vallée du Gier.' },
      { text: 'La Grand-Croix → zones commerciales et industrielles : navettes entreprises sur devis récurrent.' },
    ],
    destinations: [
      { label: 'Aéroport Lyon-Saint Exupéry', time: '~45 min · 65 km', price: '120–140 €' },
      { label: 'Gare Châteaucreux Saint-Étienne', time: '~20 min · 18 km', price: '35–45 €' },
      { label: 'CHU Saint-Étienne Nord', time: '~25 min · 22 km', price: '40–50 €' },
      { label: 'Centre Lyon Part-Dieu', time: '~50 min · 55 km', price: '90–110 €' },
    ],
    whyChoose: [
      'Disponibilité 24h/24 et 7j/7 depuis notre base La Grand-Croix — nuit, week-ends et jours fériés inclus.',
      'Connaissance fine des axes Gier, A47, A46 et des raccourcis locaux pour éviter les embouteillages.',
      'Véhicules premium (Mercedes, Audi) entretenus, climatisés et adaptés aux longues distances.',
      'Tarifs officiels arrêté préfectoral Loire 2025 : transparence, reçu et devis via calculateur en ligne.',
      'Transport médical conventionné CPAM vers CHU stéphanois et hôpitaux lyonnais.',
      'Réservation simple : un appel au 06 62 10 71 42 ou estimation immédiate sur le calculateur.',
    ],
    faq: [
      {
        q: 'Combien coûte un taxi de La Grand-Croix à l\'aéroport Lyon-Saint-Exupéry ?',
        a: 'Comptez environ 120 à 140 € selon horaire jour/nuit (65 km, ~45 min). Tarif au compteur officiel Loire ou estimation précise sur le calculateur en ligne. Réservation : 06 62 10 71 42.',
      },
      {
        q: 'Comment réserver un taxi de nuit à La Grand-Croix ?',
        a: 'Appelez le 06 62 10 71 42 à toute heure. Service nuit 24h/24 avec tarif réglementé (3,27 €/km + prise en charge 3,10 €). Prise en charge en 10 à 20 minutes en moyenne.',
      },
      {
        q: 'Faites-vous du transport médical conventionné depuis La Grand-Croix ?',
        a: 'Oui, trajets CPAM vers CHU Saint-Étienne, cliniques et hôpitaux lyonnais. Ponctualité garantie pour vos rendez-vous. Renseignements au 06 62 10 71 42.',
      },
      {
        q: 'Proposez-vous des tarifs pour les trajets réguliers La Grand-Croix ↔ Rive-de-Gier ?',
        a: 'Oui, forfaits et abonnements pour navettes professionnelles ou trajets domicile-travail dans la vallée du Gier. Contactez-nous pour un devis personnalisé.',
      },
      {
        q: 'Quel est le délai moyen pour une prise en charge à La Grand-Croix ?',
        a: 'En moyenne 10 à 15 minutes depuis notre base locale. En heure de pointe ou forte demande, nous vous communiquons un délai précis à la réservation.',
      },
    ],
    conclusion:
      'Réservez votre taxi à La Grand-Croix dès maintenant : appelez le 06 62 10 71 42 ou obtenez un devis instantané avec notre calculateur de tarifs en ligne. TAXI ABEL vous accompagne 24h/24 et 7j/7, de la course locale à la navette aéroport.',
    nearby: ['Rive-de-Gier', 'Lorette', "L'Horme", 'Saint-Chamond'],
    nearbyLinks: [
      { name: 'Rive-de-Gier', slug: 'taxi-rive-de-gier' },
      { name: 'Lorette', slug: 'taxi-lorette' },
      { name: "L'Horme", slug: 'taxi-l-horme' },
      { name: 'Saint-Chamond', slug: 'taxi-saint-chamond' },
    ],
    serviceLinks: DEFAULT_SERVICE_LINKS,
    blogLinks: [
      { slug: 'taxi-la-grand-croix-aeroport-lyon', title: 'Taxi La Grand-Croix → aéroport Lyon : tarifs et conseils' },
      { slug: 'taxi-vallee-du-gier-saint-etienne', title: 'Taxi Vallée du Gier – Saint-Étienne : itinéraires' },
      { slug: 'transport-medical-cpam-loire', title: 'Transport médical conventionné CPAM en Loire' },
    ],
  },

  'taxi-rive-de-gier': {
    name: 'Rive-de-Gier',
    slug: 'taxi-rive-de-gier',
    postalCode: '42440',
    department: 'Loire (42)',
    distanceBase: '8 km',
    highlight: 'cœur de la vallée du Gier',
    seo: {
      title: 'Taxi à Rive-de-Gier 24h/24 – Aéroport, Gare | TAXI ABEL',
      description:
        'Besoin d\'un taxi à Rive-de-Gier ? TAXI ABEL vous transporte 24h/24 vers l\'aéroport Lyon, la gare Châteaucreux et les hôpitaux. Tarifs officiels, réservation rapide.',
      h1: 'Taxi à Rive-de-Gier – Service 24h/24, Aéroport, Gare & Transport Conventionné',
    },
    intro:
      'Vous cherchez un taxi à Rive-de-Gier (42440, Loire) ? TAXI ABEL dessert le centre-ville, la gare SNCF, le secteur hospitalier, les zones commerciales et industrielles de la commune, ainsi que l\'ensemble de la Vallée du Gier. Nos chauffeurs connaissent les accès rue Jean-Jaurès, les quartiers de Rive-Gare et les axes vers Saint-Étienne ou Lyon. Courses immédiates, navettes aéroport Lyon-Saint-Exupéry, transferts gare Châteaucreux, transport CPAM et taxi de nuit : un seul numéro, 06 62 10 71 42, et un calculateur en ligne pour anticiper votre budget.',
    frequentTrips: [
      { text: 'Rive-de-Gier → Aéroport Lyon-Saint-Exupéry : environ 40 min et 60 km, prise en charge centre ou gare.' },
      { text: 'Rive-de-Gier → Gare Rive-de-Gier : 5 min, correspondances TER vers Lyon et Saint-Étienne.' },
      { text: 'Rive-de-Gier → Gare Saint-Étienne Châteaucreux : environ 15 min, liaison TGV fréquente.' },
      { text: 'Rive-de-Gier → Hôpital de Rive-de-Gier / CHU Saint-Étienne : trajets médicaux et urgences non vitales.' },
      { text: 'Rive-de-Gier → Lyon Part-Dieu / Perrache : environ 45 min, accès métropole et gares lyonnaises.' },
      { text: 'Rive-de-Gier → zones industrielles et commerciales : navettes tôt le matin et fin de journée.' },
    ],
    destinations: [
      { label: 'Gare Rive-de-Gier', time: '~5 min · 2 km', price: '8–12 €' },
      { label: 'Saint-Étienne Châteaucreux', time: '~15 min · 14 km', price: '28–38 €' },
      { label: 'Aéroport Lyon-Saint Exupéry', time: '~40 min · 60 km', price: '110–130 €' },
      { label: 'Lyon Part-Dieu', time: '~45 min · 50 km', price: '85–100 €' },
    ],
    whyChoose: [
      'Intervention rapide à Rive-de-Gier : connaissance du centre, de la gare et des zones d\'activités.',
      'Service 24h/24 — idéal sorties nocturnes, trains tardifs et vols matinaux depuis Lyon.',
      'Ponctualité gare garantie : suivi des horaires TER/TGV pour vos correspondances.',
      'Tarifs transparents arrêté Loire 2025, devis en ligne avant réservation.',
      'Transport médical vers CHU stéphanois et établissements lyonnais.',
      'Flotte confortable pour trajets pro, familles et seniors.',
    ],
    faq: [
      {
        q: 'Combien coûte un taxi de Rive-de-Gier à l\'aéroport Lyon-Saint-Exupéry ?',
        a: 'Environ 110 à 130 € (60 km, ~40 min). Utilisez le calculateur pour un tarif précis selon l\'heure de départ. Réservation : 06 62 10 71 42.',
      },
      {
        q: 'Comment réserver un taxi de nuit à Rive-de-Gier ?',
        a: 'Appelez le 06 62 10 71 42 à toute heure. Nous desservons le centre-ville, la gare et tous les quartiers, y compris les nuits de week-end.',
      },
      {
        q: 'Faites-vous du transport médical conventionné depuis Rive-de-Gier ?',
        a: 'Oui, trajets CPAM vers l\'hôpital local, le CHU de Saint-Étienne et les hôpitaux lyonnais. Prise en charge à domicile ou au pied de l\'établissement.',
      },
      {
        q: 'Proposez-vous des tarifs pour les trajets réguliers Rive-de-Gier ↔ Saint-Chamond ?',
        a: 'Forfaits disponibles pour navettes récurrentes entre communes voisines de la vallée du Gier. Demandez un devis au 06 62 10 71 42.',
      },
      {
        q: 'Quel est le délai moyen pour une prise en charge à Rive-de-Gier ?',
        a: '10 à 15 minutes en moyenne depuis notre base proche. En période de forte affluence gare, nous anticipons selon votre horaire de train.',
      },
    ],
    conclusion:
      'Réservez votre taxi à Rive-de-Gier par téléphone au 06 62 10 71 42 ou calculez votre tarif en ligne. TAXI ABEL : réactivité, confort et tarifs officiels, 24h/24 et 7j/7.',
    nearby: ['La Grand-Croix', 'Lorette', 'Saint-Chamond', 'Givors'],
    nearbyLinks: [
      { name: 'La Grand-Croix', slug: 'taxi-la-grand-croix' },
      { name: 'Lorette', slug: 'taxi-lorette' },
      { name: 'Saint-Chamond', slug: 'taxi-saint-chamond' },
      { name: 'Givors', slug: 'taxi-givors' },
    ],
    serviceLinks: DEFAULT_SERVICE_LINKS,
    blogLinks: [
      { slug: 'taxi-rive-de-gier-saint-etienne', title: 'Taxi Rive-de-Gier – Saint-Étienne : durée et tarifs' },
      { slug: 'taxi-rive-de-gier-aeroport-lyon', title: 'Navette aéroport Lyon depuis Rive-de-Gier' },
      { slug: 'taxi-gare-rive-de-gier', title: 'Taxi gare Rive-de-Gier : horaires et réservation' },
    ],
  },

  'taxi-saint-chamond': {
    name: 'Saint-Chamond',
    slug: 'taxi-saint-chamond',
    postalCode: '42400',
    department: 'Loire (42)',
    distanceBase: '15 km',
    highlight: 'portes sud de la vallée du Gier',
    seo: {
      title: 'Taxi à Saint-Chamond 24h/24 – Gare, Lyon, Aéroport | TAXI ABEL',
      description:
        'Taxi à Saint-Chamond 24h/24 : gare, hôpital, aéroport Lyon et Saint-Étienne. TAXI ABEL, chauffeur agréé vallée du Gier. Devis en ligne et tarifs officiels.',
      h1: 'Taxi à Saint-Chamond – Service 24h/24, Aéroport, Gare & Transport Conventionné',
    },
    intro:
      'TAXI ABEL assure vos déplacements à Saint-Chamond (42400, Loire), commune dynamique entre vallée du Gier et métropole stéphanoise. Du centre-ville à la gare, de l\'hôpital aux zones d\'activités de la Plaine du Drac et du Pinay, nous proposons taxi immédiat, navette aéroport, liaison gare Châteaucreux, transport médical CPAM et courses entreprises. Notre proximité avec La Grand-Croix nous permet une prise en charge rapide dans tout le secteur de Saint-Chamond, 24h/24 et 7j/7.',
    frequentTrips: [
      { text: 'Saint-Chamond → Gare Saint-Étienne Châteaucreux : environ 25 min, liaison quotidienne TGV/TER.' },
      { text: 'Saint-Chamond → Aéroport Lyon-Saint-Exupéry : environ 50 min et 70 km via A47/A46.' },
      { text: 'Saint-Chamond → CHU Saint-Étienne / cliniques : rendez-vous médicaux et hospitalisations.' },
      { text: 'Saint-Chamond → Lyon Part-Dieu : environ 40 min, accès métropole et gare TGV.' },
      { text: 'Saint-Chamond → Rive-de-Gier / La Grand-Croix : courses locales vallée du Gier.' },
      { text: 'Saint-Chamond → zones industrielles : navettes ouvriers et techniciens sur horaires décalés.' },
    ],
    destinations: [
      { label: 'Gare Châteaucreux', time: '~25 min · 20 km', price: '42–52 €' },
      { label: 'Aéroport Lyon-Saint Exupéry', time: '~50 min · 70 km', price: '115–135 €' },
      { label: 'Lyon Part-Dieu', time: '~40 min · 45 km', price: '80–95 €' },
      { label: 'La Grand-Croix', time: '~15 min · 15 km', price: '28–35 €' },
    ],
    whyChoose: [
      'Couverture complète de Saint-Chamond : centre, gare, hôpital et zones d\'activités.',
      'Expérience des trajets pro vers Saint-Étienne, Lyon et sites industriels.',
      'Disponibilité 24h/24 pour équipes en 3×8 et vols matinaux.',
      'Tarifs réglementés Loire, facturation entreprise possible.',
      'Transport médical CPAM et accompagnement seniors.',
      'Réservation au 06 62 10 71 42 ou via calculateur en ligne.',
    ],
    faq: [
      {
        q: 'Combien coûte un taxi de Saint-Chamond à l\'aéroport Lyon-Saint-Exupéry ?',
        a: 'Environ 115 à 135 € (~70 km, 50 min). Devis exact sur le calculateur ou au 06 62 10 71 42.',
      },
      {
        q: 'Comment réserver un taxi de nuit à Saint-Chamond ?',
        a: 'Un simple appel au 06 62 10 71 42 suffit. Tarif nuit officiel, véhicule identifiable et chauffeur agréé.',
      },
      {
        q: 'Faites-vous du transport médical conventionné depuis Saint-Chamond ?',
        a: 'Oui, vers CHU Saint-Étienne, hôpital local et établissements lyonnais. Trajets aller simple ou aller-retour.',
      },
      {
        q: 'Proposez-vous des navettes entreprises Saint-Chamond ↔ Saint-Étienne ?',
        a: 'Oui, abonnements et forfaits mensuels pour sites industriels et bureaux. Contact : taxiabel42@gmail.com ou 06 62 10 71 42.',
      },
      {
        q: 'Quel est le délai moyen pour une prise en charge à Saint-Chamond ?',
        a: '15 à 20 minutes selon le quartier. Nous confirmons le délai à la prise de commande.',
      },
    ],
    conclusion:
      'Votre taxi à Saint-Chamond est à un appel : 06 62 10 71 42. Estimez votre course en ligne et voyagez sereinement avec TAXI ABEL, 24h/24 et 7j/7.',
    nearby: ['La Grand-Croix', 'Rive-de-Gier', 'Firminy', 'Saint-Étienne'],
    nearbyLinks: [
      { name: 'La Grand-Croix', slug: 'taxi-la-grand-croix' },
      { name: 'Rive-de-Gier', slug: 'taxi-rive-de-gier' },
      { name: 'Saint-Étienne', slug: 'taxi-saint-etienne' },
      { name: 'Lorette', slug: 'taxi-lorette' },
    ],
    serviceLinks: DEFAULT_SERVICE_LINKS,
    blogLinks: [
      { slug: 'taxi-saint-chamond-saint-etienne', title: 'Taxi Saint-Chamond – Saint-Étienne : itinéraire et prix' },
      { slug: 'taxi-saint-chamond-lyon', title: 'Taxi Saint-Chamond – Lyon : durée et conseils trafic' },
      { slug: 'navette-entreprise-vallee-du-gier', title: 'Navettes entreprises vallée du Gier' },
    ],
  },

  'taxi-givors': {
    name: 'Givors',
    slug: 'taxi-givors',
    postalCode: '69700',
    department: 'Rhône (69)',
    distanceBase: '20 km',
    highlight: 'confluence Rhône et Gier, porte sud de Lyon',
    seo: {
      title: 'Taxi à Givors 24h/24 – Lyon, Aéroport, Gare | TAXI ABEL',
      description:
        'Taxi à Givors 24h/24 vers Lyon, aéroport Saint-Exupéry et gare. TAXI ABEL : prise en charge centre, zone industrielle et gare de Givors. Réservation immédiate.',
      h1: 'Taxi à Givors – Service 24h/24, Aéroport, Gare & Transport Conventionné',
    },
    intro:
      'Située au confluent du Gier et du Rhône, Givors (69700, Rhône) bénéficie d\'un positionnement stratégique entre Lyon et la vallée du Gier. TAXI ABEL dessert le centre-ville, la gare de Givors, les zones industrielles du Rhône et les quartiers résidentiels. Que vous recherchiez un taxi Givors pour Lyon Part-Dieu, l\'aéroport Lyon-Saint-Exupéry, Saint-Étienne ou un trajet médical, nous intervenons 24h/24 avec des tarifs officiels et un devis en ligne instantané.',
    frequentTrips: [
      { text: 'Givors → Lyon Part-Dieu / Perrache : environ 25 min, accès rapide métropole via A7 ou route nationale.' },
      { text: 'Givors → Aéroport Lyon-Saint-Exupéry : environ 35 min et 45 km, navette vols domestiques et internationaux.' },
      { text: 'Givors → Gare de Givors : liaison immédiate TER Lyon – Saint-Étienne.' },
      { text: 'Givors → La Grand-Croix / vallée du Gier : environ 25 min, retour base TAXI ABEL.' },
      { text: 'Givors → zones industrielles et portes de Lyon : navettes professionnelles matin et soir.' },
      { text: 'Givors → hôpitaux lyonnais (HCL, Croix-Rousse) : environ 30–40 min selon établissement.' },
    ],
    destinations: [
      { label: 'Lyon Part-Dieu', time: '~25 min · 22 km', price: '45–58 €' },
      { label: 'Aéroport Lyon-Saint Exupéry', time: '~35 min · 45 km', price: '70–90 €' },
      { label: 'La Grand-Croix', time: '~25 min · 22 km', price: '45–55 €' },
      { label: 'Saint-Étienne Châteaucreux', time: '~35 min · 30 km', price: '55–70 €' },
    ],
    whyChoose: [
      'Position idéale Givors : accès Lyon sud et vallée du Gier maîtrisés.',
      'Prise en charge gare de Givors et correspondances TER sans stress.',
      'Navettes aéroport avec suivi vol et ponctualité matinale.',
      'Tarifs transparents, y compris de nuit et jours fériés.',
      'Transport médical vers Lyon et Saint-Étienne.',
      'Contact direct 06 62 10 71 42 — pas d\'intermédiaire.',
    ],
    faq: [
      {
        q: 'Combien coûte un taxi de Givors à l\'aéroport Lyon-Saint-Exupéry ?',
        a: 'Environ 70 à 90 € (~45 km, 35 min). Calculateur en ligne pour estimation au centime près selon l\'horaire.',
      },
      {
        q: 'Comment réserver un taxi de nuit à Givors ?',
        a: 'Appelez le 06 62 10 71 42. Service permanent : tarif nuit 3,27 €/km + prise en charge 3,10 € (arrêté Loire).',
      },
      {
        q: 'Faites-vous du transport médical conventionné depuis Givors ?',
        a: 'Oui, vers hôpitaux lyonnais et CHU Saint-Étienne. Accompagnement soigné, ponctualité pour vos rendez-vous.',
      },
      {
        q: 'Proposez-vous des tarifs pour Givors ↔ Lyon réguliers ?',
        a: 'Forfaits hebdomadaires ou mensuels pour trajets domicile-travail vers Lyon. Devis sur demande.',
      },
      {
        q: 'Quel est le délai moyen pour une prise en charge à Givors ?',
        a: '15 à 20 minutes. Depuis la gare ou le centre, souvent plus rapide aux heures creuses.',
      },
    ],
    conclusion:
      'Réservez votre taxi à Givors : 06 62 10 71 42 ou calculateur en ligne. Lyon, aéroport, gare et vallée du Gier — TAXI ABEL vous transporte 24h/24.',
    nearby: ['Lyon', 'Mornant', 'Vienne', 'La Grand-Croix'],
    nearbyLinks: [
      { name: 'Lyon', slug: 'taxi-lyon' },
      { name: 'Mornant', slug: 'taxi-mornant' },
      { name: 'La Grand-Croix', slug: 'taxi-la-grand-croix' },
      { name: 'Rive-de-Gier', slug: 'taxi-rive-de-gier' },
    ],
    serviceLinks: DEFAULT_SERVICE_LINKS,
    blogLinks: [
      { slug: 'taxi-givors-lyon', title: 'Taxi Givors – Lyon : trajet, durée et tarifs' },
      { slug: 'taxi-givors-aeroport-lyon', title: 'Navette aéroport depuis Givors' },
      { slug: 'taxi-gare-givors', title: 'Taxi gare de Givors : correspondances TER' },
    ],
  },

  'taxi-saint-etienne': {
    name: 'Saint-Étienne',
    slug: 'taxi-saint-etienne',
    postalCode: '42000',
    department: 'Loire (42)',
    distanceBase: '12 km',
    highlight: 'métropole stéphanoise, CHU et gare Châteaucreux',
    seo: {
      title: 'Taxi à Saint-Étienne 24h/24 – Gare, CHU, Aéroport | TAXI ABEL',
      description:
        'Taxi à Saint-Étienne 24h/24 : gare Châteaucreux, CHU, aéroport Lyon et transport CPAM. TAXI ABEL depuis la vallée du Gier. Devis en ligne, tarifs officiels.',
      h1: 'Taxi à Saint-Étienne – Service 24h/24, Aéroport, Gare & Transport Conventionné',
    },
    intro:
      'Saint-Étienne (42000 et communes limitrophes, Loire) est un hub majeur pour TAXI ABEL : gare Châteaucreux, CHU Nord et Bellevue, universités, zones commerciales de Monthieu ou de la Cité du design. Nous assurons taxi Saint-Étienne depuis la vallée du Gier et au départ de la métropole vers Lyon, les aéroports, les gares et les hôpitaux. Transport conventionné CPAM, courses de nuit, navettes entreprises : un service professionnel 24h/24, tarifs arrêté préfectoral Loire 2025.',
    frequentTrips: [
      { text: 'Saint-Étienne → Aéroport Lyon-Saint-Exupéry : environ 55 min et 80 km, idéal vols internationaux.' },
      { text: 'Saint-Étienne → Gare Châteaucreux : prise en charge quartiers, hôtels et CHU pour TGV/TER.' },
      { text: 'Saint-Étienne → CHU Nord / Bellevue / Métropole : trajets médicaux quotidiens.' },
      { text: 'Saint-Étienne → Lyon Part-Dieu / Perrache : environ 50 min, liaison métropoles.' },
      { text: 'Saint-Étienne → La Grand-Croix / vallée du Gier : retour domicile après consultation ou travail.' },
      { text: 'Saint-Étienne → zones commerciales Monthieu, centre-ville : courses locales et shopping.' },
    ],
    destinations: [
      { label: 'Aéroport Lyon-Saint Exupéry', time: '~55 min · 80 km', price: '130–150 €' },
      { label: 'Gare Châteaucreux', time: '~5–20 min · local', price: '8–45 €' },
      { label: 'CHU Nord / Bellevue', time: '~10–25 min', price: '15–55 €' },
      { label: 'La Grand-Croix', time: '~20 min · 18 km', price: '35–42 €' },
    ],
    whyChoose: [
      'Expertise métropole stéphanoise : gares, hôpitaux, campus et axes A72/A47.',
      'Ponctualité CHU et gare — priorité aux rendez-vous médicaux et TGV.',
      'Liaison directe vallée du Gier ↔ Saint-Étienne plusieurs fois par jour.',
      'Véhicules confortables pour longues distances vers Lyon et aéroports.',
      'Tarifs officiels, reçu et devis calculateur.',
      'Réservation 06 62 10 71 42 — disponible 24h/24.',
    ],
    faq: [
      {
        q: 'Combien coûte un taxi de Saint-Étienne à l\'aéroport Lyon-Saint-Exupéry ?',
        a: 'Environ 130 à 150 € (~80 km, 55 min). Le calculateur en ligne intègre horaire jour/nuit pour une estimation fiable.',
      },
      {
        q: 'Comment réserver un taxi de nuit à Saint-Étienne ?',
        a: 'Appelez le 06 62 10 71 42. Nous desservons Châteaucreux, centre, quartiers périphériques et sorties nocturnes.',
      },
      {
        q: 'Faites-vous du transport médical conventionné à Saint-Étienne ?',
        a: 'Oui, CHU complet, cliniques stéphanoises et transferts vers Lyon. Convention CPAM — renseignements à la réservation.',
      },
      {
        q: 'Proposez-vous des tarifs Saint-Étienne ↔ La Grand-Croix réguliers ?',
        a: 'Forfaits domicile-travail et navettes médicales récurrentes. Devis personnalisé au 06 62 10 71 42.',
      },
      {
        q: 'Quel est le délai moyen pour une prise en charge à Saint-Étienne ?',
        a: '10 à 25 minutes selon secteur (centre plus rapide). Nous adaptons pour les trains avec numéro de dossier.',
      },
    ],
    conclusion:
      'Réservez votre taxi à Saint-Étienne : 06 62 10 71 42 ou devis en ligne. Gare, CHU, aéroport — TAXI ABEL, votre chauffeur de confiance 24h/24.',
    nearby: ['La Grand-Croix', 'Saint-Chamond', 'Firminy', 'Unieux'],
    nearbyLinks: [
      { name: 'La Grand-Croix', slug: 'taxi-la-grand-croix' },
      { name: 'Saint-Chamond', slug: 'taxi-saint-chamond' },
      { name: 'Rive-de-Gier', slug: 'taxi-rive-de-gier' },
      { name: 'Lyon', slug: 'taxi-lyon' },
    ],
    serviceLinks: DEFAULT_SERVICE_LINKS,
    blogLinks: [
      { slug: 'taxi-saint-etienne-aeroport-lyon', title: 'Taxi Saint-Étienne – aéroport Lyon : guide complet' },
      { slug: 'taxi-gare-chateaurcreux', title: 'Taxi gare Châteaucreux : horaires et réservation' },
      { slug: 'transport-medical-chu-saint-etienne', title: 'Transport médical CHU Saint-Étienne' },
    ],
  },

  'taxi-l-horme': {
    name: "L'Horme",
    slug: 'taxi-l-horme',
    postalCode: '42152',
    department: 'Loire (42)',
    distanceBase: '6 km',
    highlight: 'commune de la vallée du Gier',
    seo: {
      title: 'Taxi à L\'Horme 24h/24 – Saint-Étienne, Aéroport | TAXI ABEL',
      description:
        'Taxi à L\'Horme 24h/24 vers Saint-Étienne, aéroport Lyon et gares. TAXI ABEL, vallée du Gier. Prise en charge rapide, tarifs officiels Loire.',
      h1: 'Taxi à L\'Horme – Service 24h/24, Aéroport, Gare & Transport Conventionné',
    },
    intro:
      'L\'Horme (42152, Loire) est une commune de la Vallée du Gier que TAXI ABEL dessert quotidiennement depuis sa base voisine de La Grand-Croix. Que vous habitiez le bourg, les hameaux ou les secteurs proches de Rive-de-Gier et Saint-Chamond, nous garantissons une prise en charge rapide pour vos courses locales, vos rendez-vous à Saint-Étienne, vos transferts gare ou aéroport Lyon, ainsi que le transport médical conventionné. Taxi L\'Horme disponible 24h/24 — réservez au 06 62 10 71 42.',
    frequentTrips: [
      { text: 'L\'Horme → Saint-Étienne Châteaucreux : environ 20 min, liaison métropole et CHU.' },
      { text: 'L\'Horme → Aéroport Lyon-Saint-Exupéry : environ 48 min et 68 km.' },
      { text: 'L\'Horme → Rive-de-Gier / gare : environ 10 min, correspondances TER.' },
      { text: 'L\'Horme → CHU Saint-Étienne : trajets médicaux et hospitalisations.' },
      { text: 'L\'Horme → Lyon Part-Dieu : environ 50 min via A47.' },
      { text: 'L\'Horme → Saint-Chamond : courses locales et navettes travail.' },
    ],
    destinations: [
      { label: 'Saint-Étienne Châteaucreux', time: '~20 min · 16 km', price: '35–45 €' },
      { label: 'Aéroport Lyon-Saint Exupéry', time: '~48 min · 68 km', price: '118–138 €' },
      { label: 'Rive-de-Gier gare', time: '~10 min · 8 km', price: '18–25 €' },
      { label: 'Lyon Part-Dieu', time: '~50 min · 52 km', price: '88–105 €' },
    ],
    whyChoose: [
      'Proximité immédiate : intervention en 10–15 min à L\'Horme en moyenne.',
      'Connaissance des routes vallée du Gier et accès vers Saint-Étienne.',
      'Service 24h/24 pour urgences, nuit et RDV matinaux.',
      'Tarifs officiels Loire, sans surprise.',
      'Transport CPAM vers CHU et hôpitaux lyonnais.',
      'Devis en ligne et réservation téléphonique simple.',
    ],
    faq: [
      {
        q: 'Combien coûte un taxi de L\'Horme à l\'aéroport Lyon-Saint-Exupéry ?',
        a: 'Environ 118 à 138 € (~68 km, 48 min). Estimation précise sur le calculateur ou au 06 62 10 71 42.',
      },
      {
        q: 'Comment réserver un taxi de nuit à L\'Horme ?',
        a: 'Appelez le 06 62 10 71 42 à toute heure. Prise en charge au domicile, tarif nuit réglementé.',
      },
      {
        q: 'Faites-vous du transport médical conventionné depuis L\'Horme ?',
        a: 'Oui, trajets CPAM vers Saint-Étienne et Lyon. Nous veillons à la ponctualité de vos rendez-vous.',
      },
      {
        q: 'Proposez-vous des tarifs L\'Horme ↔ Rive-de-Gier réguliers ?',
        a: 'Forfaits possibles pour trajets récurrents dans la vallée du Gier. Contactez TAXI ABEL pour un devis.',
      },
      {
        q: 'Quel est le délai moyen pour une prise en charge à L\'Horme ?',
        a: '10 à 15 minutes grâce à notre base proche à La Grand-Croix.',
      },
    ],
    conclusion:
      'Votre taxi à L\'Horme : 06 62 10 71 42 ou calculateur en ligne. TAXI ABEL, réactivité et confort 24h/24 dans la vallée du Gier.',
    nearby: ['Lorette', 'La Grand-Croix', 'Rive-de-Gier', 'Saint-Chamond'],
    nearbyLinks: [
      { name: 'Lorette', slug: 'taxi-lorette' },
      { name: 'La Grand-Croix', slug: 'taxi-la-grand-croix' },
      { name: 'Rive-de-Gier', slug: 'taxi-rive-de-gier' },
      { name: 'Saint-Chamond', slug: 'taxi-saint-chamond' },
    ],
    serviceLinks: DEFAULT_SERVICE_LINKS,
    blogLinks: [
      { slug: 'taxi-l-horme-saint-etienne', title: 'Taxi L\'Horme – Saint-Étienne : durée et tarif' },
      { slug: 'taxi-vallee-du-gier-guide', title: 'Guide taxi vallée du Gier' },
      { slug: 'taxi-l-horme-aeroport-lyon', title: 'Navette aéroport Lyon depuis L\'Horme' },
    ],
  },

  'taxi-lorette': {
    name: 'Lorette',
    slug: 'taxi-lorette',
    postalCode: '42420',
    department: 'Loire (42)',
    distanceBase: '5 km',
    highlight: 'vallée du Gier, proximité La Grand-Croix',
    seo: {
      title: 'Taxi à Lorette 24h/24 – Saint-Étienne, Lyon | TAXI ABEL',
      description:
        'Taxi à Lorette 24h/24 : Saint-Étienne, Lyon, aéroport et gare. TAXI ABEL vallée du Gier. Prise en charge rapide, transport CPAM, tarifs officiels.',
      h1: 'Taxi à Lorette – Service 24h/24, Aéroport, Gare & Transport Conventionné',
    },
    intro:
      'Lorette (42420, Loire) fait partie des communes de la Vallée du Gier que TAXI ABEL couvre en priorité depuis La Grand-Croix, à quelques minutes seulement. Besoin d\'un taxi Lorette pour Saint-Étienne, Lyon, la gare de Rive-de-Gier ou l\'aéroport Lyon-Saint-Exupéry ? Nous proposons un service fiable, 24h/24 et 7j/7, avec véhicules confortables et tarifs transparents. Transport médical conventionné, courses nocturnes et navettes professionnelles : contactez le 06 62 10 71 42.',
    frequentTrips: [
      { text: 'Lorette → Saint-Étienne Châteaucreux : environ 18 min, accès gare et CHU.' },
      { text: 'Lorette → Aéroport Lyon-Saint-Exupéry : environ 46 min et 63 km.' },
      { text: 'Lorette → Rive-de-Gier : environ 8 min, courses locales fréquentes.' },
      { text: 'Lorette → Lyon Part-Dieu : environ 48 min selon trafic A47.' },
      { text: 'Lorette → CHU Saint-Étienne : rendez-vous médicaux et soins de longue durée.' },
      { text: 'Lorette → La Grand-Croix / L\'Horme : liaisons inter-communes vallée du Gier.' },
    ],
    destinations: [
      { label: 'Saint-Étienne Châteaucreux', time: '~18 min · 15 km', price: '32–40 €' },
      { label: 'Aéroport Lyon-Saint Exupéry', time: '~46 min · 63 km', price: '115–135 €' },
      { label: 'Rive-de-Gier', time: '~8 min · 6 km', price: '12–18 €' },
      { label: 'Lyon Part-Dieu', time: '~48 min · 50 km', price: '88–105 €' },
    ],
    whyChoose: [
      'Intervention ultra-rapide à Lorette grâce à la base La Grand-Croix voisine.',
      'Couverture complète vallée du Gier : Lorette, L\'Horme, Rive-de-Gier.',
      'Disponibilité 24h/24, week-ends et jours fériés.',
      'Chauffeur agréé Loire, tarifs arrêté 2025.',
      'Transport CPAM et accompagnement personnes âgées.',
      'Réservation téléphone ou calculateur en ligne.',
    ],
    faq: [
      {
        q: 'Combien coûte un taxi de Lorette à l\'aéroport Lyon-Saint-Exupéry ?',
        a: 'Environ 115 à 135 € (~63 km, 46 min). Devis instantané sur le calculateur.',
      },
      {
        q: 'Comment réserver un taxi de nuit à Lorette ?',
        a: 'Appelez le 06 62 10 71 42. Service permanent, prise en charge à domicile.',
      },
      {
        q: 'Faites-vous du transport médical conventionné depuis Lorette ?',
        a: 'Oui, vers CHU Saint-Étienne et hôpitaux lyonnais. Trajets CPAM sur prescription.',
      },
      {
        q: 'Proposez-vous des tarifs Lorette ↔ Rive-de-Gier réguliers ?',
        a: 'Forfaits pour trajets domicile-travail ou scolaires dans la vallée. Renseignements au 06 62 10 71 42.',
      },
      {
        q: 'Quel est le délai moyen pour une prise en charge à Lorette ?',
        a: '8 à 12 minutes en moyenne — parmi les plus courts de notre secteur.',
      },
    ],
    conclusion:
      'Réservez votre taxi à Lorette : 06 62 10 71 42 ou devis en ligne. TAXI ABEL, votre partenaire mobilité 24h/24 en vallée du Gier.',
    nearby: ['La Grand-Croix', "L'Horme", 'Rive-de-Gier', 'Saint-Chamond'],
    nearbyLinks: [
      { name: 'La Grand-Croix', slug: 'taxi-la-grand-croix' },
      { name: "L'Horme", slug: 'taxi-l-horme' },
      { name: 'Rive-de-Gier', slug: 'taxi-rive-de-gier' },
      { name: 'Saint-Chamond', slug: 'taxi-saint-chamond' },
    ],
    serviceLinks: DEFAULT_SERVICE_LINKS,
    blogLinks: [
      { slug: 'taxi-lorette-saint-etienne', title: 'Taxi Lorette – Saint-Étienne : itinéraire' },
      { slug: 'taxi-lorette-aeroport-lyon', title: 'Taxi Lorette – aéroport Lyon' },
      { slug: 'taxi-communes-vallee-du-gier', title: 'Taxi dans les communes de la vallée du Gier' },
    ],
  },

  'taxi-mornant': {
    name: 'Mornant',
    slug: 'taxi-mornant',
    postalCode: '69440',
    department: 'Rhône (69)',
    distanceBase: '18 km',
    highlight: 'sud du Rhône, entre Givors et Lyon',
    seo: {
      title: 'Taxi à Mornant 24h/24 – Lyon, Aéroport, Givors | TAXI ABEL',
      description:
        'Taxi à Mornant 24h/24 vers Lyon, aéroport Saint-Exupéry et Givors. TAXI ABEL : courses locales, gare, transport CPAM. Réservation 06 62 10 71 42.',
      h1: 'Taxi à Mornant – Service 24h/24, Aéroport, Gare & Transport Conventionné',
    },
    intro:
      'Mornant (69440, Rhône) est une commune du sud lyonnais que TAXI ABEL dessert depuis la vallée du Gier et Givors. Idéalement située entre Lyon, Givors et les axes vers Saint-Étienne, Mornant bénéficie de liaisons taxi vers la métropole, l\'aéroport Lyon-Saint-Exupéry, la gare de Givors et les hôpitaux lyonnais. Service 24h/24, tarifs officiels, transport médical et devis en ligne : votre taxi Mornant est joignable au 06 62 10 71 42.',
    frequentTrips: [
      { text: 'Mornant → Lyon centre / Part-Dieu : environ 35 min et 30 km via A7 ou routes secondaires.' },
      { text: 'Mornant → Aéroport Lyon-Saint-Exupéry : environ 40 min, navette vols affaires et vacances.' },
      { text: 'Mornant → Givors gare : environ 15 min, correspondances TER.' },
      { text: 'Mornant → Saint-Étienne : environ 45 min via Givors et vallée du Gier.' },
      { text: 'Mornant → hôpitaux lyonnais : transferts médicaux HCL et spécialistes.' },
      { text: 'Mornant → zones commerciales sud Lyon : courses locales et livraisons pro.' },
    ],
    destinations: [
      { label: 'Lyon Part-Dieu', time: '~35 min · 30 km', price: '70–85 €' },
      { label: 'Aéroport Lyon-Saint Exupéry', time: '~40 min · 40 km', price: '75–90 €' },
      { label: 'Givors gare', time: '~15 min · 12 km', price: '25–35 €' },
      { label: 'La Grand-Croix', time: '~30 min · 25 km', price: '50–60 €' },
    ],
    whyChoose: [
      'Couverture Mornant et communes voisines du Rhône sud.',
      'Accès optimisé Lyon et aéroport sans stress de stationnement.',
      'Liaison vallée du Gier – Mornant pour familles et professionnels.',
      'Disponibilité 24h/24, tarifs jour/nuit transparents.',
      'Transport médical vers Lyon et Saint-Étienne.',
      'Réservation directe sans application tierce.',
    ],
    faq: [
      {
        q: 'Combien coûte un taxi de Mornant à l\'aéroport Lyon-Saint-Exupéry ?',
        a: 'Environ 75 à 90 € (~40 km, 40 min). Calculateur en ligne pour affiner selon l\'horaire.',
      },
      {
        q: 'Comment réserver un taxi de nuit à Mornant ?',
        a: 'Appelez le 06 62 10 71 42. Prise en charge nocturne, retour de soirée Lyon ou Givors.',
      },
      {
        q: 'Faites-vous du transport médical conventionné depuis Mornant ?',
        a: 'Oui, vers hôpitaux lyonnais et CHU Saint-Étienne. Ponctualité pour dialyse, chimio et consultations.',
      },
      {
        q: 'Proposez-vous des tarifs Mornant ↔ Givors réguliers ?',
        a: 'Forfaits hebdomadaires possibles. Contactez-nous pour un devis adapté.',
      },
      {
        q: 'Quel est le délai moyen pour une prise en charge à Mornant ?',
        a: '15 à 25 minutes selon disponibilité flotte. Nous confirmons à l\'appel.',
      },
    ],
    conclusion:
      'Réservez votre taxi à Mornant : 06 62 10 71 42 ou estimation en ligne. Lyon, aéroport, Givors — TAXI ABEL 24h/24.',
    nearby: ['Givors', 'Lyon', 'La Grand-Croix', 'Saint-Étienne'],
    nearbyLinks: [
      { name: 'Givors', slug: 'taxi-givors' },
      { name: 'Lyon', slug: 'taxi-lyon' },
      { name: 'La Grand-Croix', slug: 'taxi-la-grand-croix' },
      { name: 'Saint-Étienne', slug: 'taxi-saint-etienne' },
    ],
    serviceLinks: DEFAULT_SERVICE_LINKS,
    blogLinks: [
      { slug: 'taxi-mornant-lyon', title: 'Taxi Mornant – Lyon : trajet et tarifs' },
      { slug: 'taxi-mornant-aeroport-lyon', title: 'Navette aéroport depuis Mornant' },
      { slug: 'taxi-sud-rhone-givors', title: 'Taxi sud Rhône : Givors et environs' },
    ],
  },

  'taxi-lyon': {
    name: 'Lyon',
    slug: 'taxi-lyon',
    postalCode: '69000',
    department: 'Rhône (69)',
    distanceBase: '40 km',
    highlight: 'métropole lyonnaise, Part-Dieu et aéroport',
    seo: {
      title: 'Taxi Lyon 24h/24 – Aéroport, Gare, Vallée du Gier | TAXI ABEL',
      description:
        'Taxi Lyon et depuis la vallée du Gier 24h/24. Aéroport Saint-Exupéry, Part-Dieu, Perrache, hôpitaux. TAXI ABEL : tarifs officiels, réservation rapide.',
      h1: 'Taxi à Lyon – Service 24h/24, Aéroport, Gare & Transport Conventionné',
    },
    intro:
      'TAXI ABEL assure vos trajets taxi à Lyon (69000 et métropole) au départ de la vallée du Gier, Givors ou directement depuis Lyon : Part-Dieu, Perrache, Presqu\'île, Confluence, hôpitaux HCL et aéroport Lyon-Saint-Exupéry. Chauffeur connaissant les axes A7, A46, rocade est et les accès gares, nous garantissons ponctualité pour vos vols, TGV et rendez-vous médicaux. Service 24h/24, tarifs officiels Loire/Rhône, devis calculateur et réservation au 06 62 10 71 42.',
    frequentTrips: [
      { text: 'Lyon → Aéroport Lyon-Saint-Exupéry : environ 30 min depuis Part-Dieu, navette terminals 1 et 2.' },
      { text: 'Vallée du Gier → Lyon Part-Dieu : environ 50 min depuis La Grand-Croix.' },
      { text: 'Lyon → Gare Perrache / Part-Dieu : transferts correspondances et hôtels.' },
      { text: 'Lyon → Hôpitaux HCL, Croix-Rousse, cardiologie : transport médical conventionné.' },
      { text: 'Lyon → Saint-Étienne Châteaucreux : environ 50 min, liaison inter-métropoles.' },
      { text: 'Lyon → Givors / vallée du Gier : retour domicile après journée pro ou médicale.' },
    ],
    destinations: [
      { label: 'Aéroport Lyon-Saint Exupéry', time: '~30 min · 25 km', price: '55–70 €' },
      { label: 'Gare Part-Dieu', time: '~45 min · 55 km', price: '90–110 €' },
      { label: 'La Grand-Croix', time: '~50 min · 55 km', price: '90–110 €' },
      { label: 'Saint-Étienne Châteaucreux', time: '~50 min · 65 km', price: '95–115 €' },
    ],
    whyChoose: [
      'Expertise métropole lyonnaise : gares, aéroport, hôpitaux, quartiers d\'affaires.',
      'Départs vallée du Gier et Givors vers Lyon sans changement de véhicule.',
      'Suivi vol pour navettes aéroport, aide bagages incluse.',
      'Tarifs transparents, devis avant course longue distance.',
      'Transport CPAM vers instituts lyonnais spécialisés.',
      'Joignable 24h/24 au 06 62 10 71 42.',
    ],
    faq: [
      {
        q: 'Combien coûte un taxi de La Grand-Croix à Lyon Part-Dieu ?',
        a: 'Environ 90 à 110 € (~55 km, 50 min). Le calculateur en ligne détaille jour/nuit.',
      },
      {
        q: 'Comment réserver un taxi de nuit à Lyon ?',
        a: 'Appelez le 06 62 10 71 42. Nous desservons toute la métropole et les retours vers la vallée du Gier.',
      },
      {
        q: 'Faites-vous du transport médical vers les hôpitaux lyonnais ?',
        a: 'Oui, HCL, Croix-Rousse, instituts cardio et oncologie. Départ vallée du Gier ou Lyon.',
      },
      {
        q: 'Proposez-vous des navettes Lyon ↔ vallée du Gier régulières ?',
        a: 'Forfaits entreprises et particuliers pour trajets récurrents. Devis sur taxiabel42@gmail.com.',
      },
      {
        q: 'Quel est le délai pour une prise en charge à Lyon ?',
        a: 'Variable selon secteur lyonnais (15–30 min). Pour départs vallée du Gier, planifiez à l\'avance via réservation.',
      },
    ],
    conclusion:
      'Réservez votre taxi Lyon ou vers Lyon : 06 62 10 71 42 ou calculateur en ligne. Aéroport, gares, hôpitaux — TAXI ABEL 24h/24.',
    nearby: ['Givors', 'Saint-Genis-Laval', 'Oullins', 'Vienne'],
    nearbyLinks: [
      { name: 'Givors', slug: 'taxi-givors' },
      { name: 'La Grand-Croix', slug: 'taxi-la-grand-croix' },
      { name: 'Saint-Étienne', slug: 'taxi-saint-etienne' },
      { name: 'Mornant', slug: 'taxi-mornant' },
    ],
    serviceLinks: DEFAULT_SERVICE_LINKS,
    blogLinks: [
      { slug: 'taxi-lyon-aeroport-saint-exupery', title: 'Taxi Lyon – aéroport Saint-Exupéry : guide pratique' },
      { slug: 'taxi-vallee-du-gier-lyon', title: 'Taxi vallée du Gier – Lyon : durée et prix' },
      { slug: 'hopitaux-lyonnais-transport', title: 'Transport vers les hôpitaux lyonnais' },
    ],
  },
};

/**
 * Liens blog → pages ville (à ajouter dans le corps des articles correspondants) :
 * - Chaque article listé dans city.blogLinks devrait contenir un lien vers /{city.slug}
 * - Exemple : article "taxi-rive-de-gier-aeroport-lyon" → lien "Taxi Rive-de-Gier" vers /taxi-rive-de-gier
 */

function getCitySeoMeta(slug) {
  const city = CITY_PAGES[slug];
  if (!city) return null;
  return {
    type: 'city',
    title: city.seo.title,
    description: city.seo.description,
    h1: city.seo.h1,
    data: city,
  };
}

export { CONTACT, DEFAULT_SERVICE_LINKS, CITY_PAGES, getCitySeoMeta };
